var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/types/analytics-client.ts
var WidgetOutgoingEventName = /* @__PURE__ */ ((WidgetOutgoingEventName2) => {
  WidgetOutgoingEventName2["TrackAnalyticsData"] = "TrackAnalyticsData";
  return WidgetOutgoingEventName2;
})(WidgetOutgoingEventName || {});
var WidgetIncomingEventName = /* @__PURE__ */ ((WidgetIncomingEventName2) => {
  WidgetIncomingEventName2["AnalyticsApplicationProperties"] = "AnalyticsApplicationProperties";
  return WidgetIncomingEventName2;
})(WidgetIncomingEventName || {});

// src/analytics-client.ts
import { v4 as uuid } from "uuid";

// src/types/index.ts
var BtnType = /* @__PURE__ */ ((BtnType2) => {
  BtnType2["TINY"] = "tiny";
  BtnType2["SMALL"] = "small";
  BtnType2["LARGE"] = "large";
  BtnType2["HUGE"] = "huge";
  BtnType2["PILL"] = "pill";
  BtnType2["LINK"] = "link";
  BtnType2["OUTLINT"] = "outline";
  BtnType2["DROPDOWN"] = "dropdown";
  BtnType2["DROPDOWN_OPTION"] = "dropdownOption";
  BtnType2["TAB"] = "tab";
  return BtnType2;
})(BtnType || {});
var ActionButtonAction = /* @__PURE__ */ ((ActionButtonAction2) => {
  ActionButtonAction2["SELECT"] = "SELECT";
  ActionButtonAction2["SUBMIT_CASE"] = "SUBMIT_CASE";
  ActionButtonAction2["SEE_MORE_RESULT"] = "SEE_MORE_RESULT";
  ActionButtonAction2["SEE_MORE_DETAILS"] = "SEE_MORE_DETAILS";
  return ActionButtonAction2;
})(ActionButtonAction || {});
var MessageType = /* @__PURE__ */ ((MessageType2) => {
  MessageType2["SendDataToApp"] = "vim-connect-send-data-to-app";
  MessageType2["SendDataToVimConnectHub"] = "vim-connect-send-data-to-vim-connect-ui";
  MessageType2["WidgetReady"] = "vim-connect-widget-ready";
  return MessageType2;
})(MessageType || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["VCHubSendToRuntime"] = "vim-connect-ui-send-to-runtime";
  EventType2["VCHubWidgetSendToApp"] = "vim-connect-ui-widget-send-data-to-app";
  EventType2["WidgetReady"] = "vim-connect-widget-ready";
  EventType2["VCHubSendToNotifications"] = "vim-connect-ui-send-data-to-notifications";
  EventType2["VCNewModifyApplication"] = "vim-connect-ui-new-modify-application";
  EventType2["NotificationsSendToVCHub"] = "notifications-send-data-to-vim-connect-ui";
  EventType2["OpenApp"] = "open-app";
  return EventType2;
})(EventType || {});
var NotificationEvent = /* @__PURE__ */ ((NotificationEvent2) => {
  NotificationEvent2["Show"] = "vim-connect-ui-show-notification";
  NotificationEvent2["Hide"] = "vim-connect-ui-hide-notification";
  return NotificationEvent2;
})(NotificationEvent || {});

// src/messaging.ts
var sendDataToApp = (payload, type = "vim-connect-send-data-to-app" /* SendDataToApp */) => {
  if (window.$vimConnectParentPort) {
    window.$vimConnectParentPort.postMessage({ type, payload });
  } else {
    parent.postMessage({ type, payload }, "*");
  }
};
var sendDataToVimConnectUI = (payload) => {
  sendDataToApp(payload, "vim-connect-send-data-to-vim-connect-ui" /* SendDataToVimConnectHub */);
};
var sendEventToAppVimConnectUIWidget = (widgetId, event, data) => {
  sendDataToVimConnectUI({
    event: "vim-connect-ui-send-to-runtime" /* VCHubSendToRuntime */,
    data: { event, widgetId, data }
  });
};
var sendEventToApp = (event, data) => {
  sendDataToApp({ event, data });
};
var addAppDataListener = (dataArrivalCallback, eventTypes) => {
  const messageEventListener = (message) => {
    const { type, payload } = message.data;
    if (eventTypes.find((item) => item === type))
      dataArrivalCallback(payload, message);
  };
  window.addEventListener("message", messageEventListener);
  return () => {
    window.removeEventListener("message", messageEventListener);
  };
};
var vimConnectUIEventListenerRemover = void 0;
var vimConnectUIWidgetEventListenerRemover = void 0;
var registerVimConnectUI = (dataArrivalCallback) => {
  const newListenerRemover = registerWidget(dataArrivalCallback, [
    "vim-connect-send-data-to-vim-connect-ui" /* SendDataToVimConnectHub */
  ]);
  vimConnectUIEventListenerRemover == null ? void 0 : vimConnectUIEventListenerRemover();
  vimConnectUIEventListenerRemover = newListenerRemover;
};
var registerWidget = (dataArrivalCallback, additionalEventTypes) => {
  const notifyReady = () => sendDataToApp({ type: "vim-connect-widget-ready" /* WidgetReady */ });
  return registerWidgetBase(dataArrivalCallback, notifyReady, additionalEventTypes);
};
var registerVimConnectUIWidget = (widgetId, dataArrivalCallback) => {
  const notifyReady = () => sendEventToAppVimConnectUIWidget(widgetId, "vim-connect-widget-ready" /* WidgetReady */);
  const newListenerRemover = registerWidgetBase(dataArrivalCallback, notifyReady);
  vimConnectUIWidgetEventListenerRemover == null ? void 0 : vimConnectUIWidgetEventListenerRemover();
  vimConnectUIWidgetEventListenerRemover = newListenerRemover;
  return vimConnectUIWidgetEventListenerRemover;
};
var registerWidgetBase = (dataArrivalCallback, notifyReady, additionalEventTypes) => {
  const eventTypes = ["vim-connect-send-data-to-widget"];
  if (additionalEventTypes)
    eventTypes.push(...additionalEventTypes);
  const listenerRemover = addAppDataListener((payload, browserEvent) => {
    const { type } = payload != null ? payload : {};
    if (type === "vim-connect-widget-ready-check") {
      notifyReady();
      return;
    }
    dataArrivalCallback(payload, browserEvent);
  }, eventTypes);
  notifyReady();
  return listenerRemover;
};
var registerWidgetToEvent = (event, listener) => registerWidget((payload) => {
  if ((payload == null ? void 0 : payload.event) === event)
    listener(payload.data, payload.event);
});

// src/analytics-client.ts
var AnalyticsClient = class {
  constructor(vimConnectUIWidgetId) {
    this.vimConnectUIWidgetId = vimConnectUIWidgetId;
    const incomingHandler = (payload) => {
      const { event, data } = payload;
      if (event === "AnalyticsApplicationProperties" /* AnalyticsApplicationProperties */) {
        this.applicationProperties = data;
      }
    };
    addAppDataListener(incomingHandler.bind(this), ["vim-connect-send-data-to-widget"]);
  }
  track(event, properties) {
    const enrichedProperties = __spreadValues(__spreadValues(__spreadValues({
      vim_patient_id: this.vimPatientId,
      active_session_id: this.activeSessionId,
      opened_session_id: this.openedSessionId,
      widget_id: this.vimConnectUIWidgetId
    }, this.dynamicWidgetProperties), this.applicationProperties), properties);
    if (this.vimConnectUIWidgetId) {
      sendEventToAppVimConnectUIWidget(this.vimConnectUIWidgetId, "TrackAnalyticsData" /* TrackAnalyticsData */, {
        event,
        properties: enrichedProperties
      });
    } else {
      sendDataToApp({
        type: "vim-connect-widget-analytics-track",
        event,
        properties: enrichedProperties
      });
    }
  }
  setVimPatientId(vimPatientId) {
    this.vimPatientId = vimPatientId;
  }
  resetVimPatientId() {
    this.vimPatientId = void 0;
  }
  setNewActiveSessionId() {
    this.activeSessionId = uuid();
  }
  resetActiveSessionId() {
    this.activeSessionId = void 0;
  }
  setNewOpenedSessionId() {
    this.openedSessionId = uuid();
  }
  resetOpenedSessionId() {
    this.openedSessionId = void 0;
  }
  setDynamicWidgetProperties(dynamicProperties) {
    this.dynamicWidgetProperties = dynamicProperties;
  }
};

// src/syncMessaging.ts
import { v4 as uuid2 } from "uuid";
var SYNC_EVENT_TIMEOUT = 6e4;
var addSyncListener = (syncEventId) => {
  const waitingForResponse = new Promise((resolve, reject) => {
    const removeListener = addAppDataListener((payload) => {
      const { syncEventId: incomingSyncEventId, data } = payload != null ? payload : {};
      if (incomingSyncEventId === syncEventId) {
        clearTimeout(timeout);
        resolve(data);
        removeListener();
      }
    }, ["vim-connect-send-data-to-widget"]);
    const timeout = setTimeout(() => {
      reject("Timeout error! event took too long to respond!");
      removeListener();
    }, SYNC_EVENT_TIMEOUT);
  });
  return waitingForResponse;
};
var sendSyncEventToApp = (event, data) => {
  const syncEventId = uuid2();
  sendDataToApp({ event, data, syncEventId });
  return addSyncListener(syncEventId);
};
var sendSyncEventToVimConnectHubApp = (widgetId, event, data) => {
  const syncEventId = uuid2();
  sendDataToVimConnectUI({
    event: "vim-connect-ui-send-to-runtime" /* VCHubSendToRuntime */,
    data: { event, widgetId, syncEventId, data }
  });
  return addSyncListener(syncEventId);
};
export {
  ActionButtonAction,
  AnalyticsClient,
  BtnType,
  EventType,
  MessageType,
  NotificationEvent,
  WidgetIncomingEventName,
  WidgetOutgoingEventName,
  addAppDataListener,
  registerVimConnectUI,
  registerVimConnectUIWidget,
  registerWidget,
  registerWidgetBase,
  registerWidgetToEvent,
  sendDataToApp,
  sendDataToVimConnectUI,
  sendEventToApp,
  sendEventToAppVimConnectUIWidget,
  sendSyncEventToApp,
  sendSyncEventToVimConnectHubApp
};
//# sourceMappingURL=index.js.map
